export default __webpack_public_path__ + "static/media/aoni-logo-disabled.9684c892.svg";